"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactUse = require("react-use");
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _FullPageProgress = _interopRequireDefault(require("./FullPageProgress"));
var _RoleChangeRequestModal = require("./RoleChangeRequestModal");
var _mainView = require("../layouts/mainView");
var _Header = require("./Header");
var _Footer = require("./Footer");
var _useNavigation = require("./hooks/useNavigation");
var _useUISettings = require("./AppData/useUISettings");
var _utils = require("../common/utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Conference = function Conference() {
  var navigate = (0, _useNavigation.useNavigation)();
  var _useParams = (0, _reactRouterDom.useParams)(),
    sessionId = _useParams.sessionId,
    token = _useParams.token;
  var isHeadless = (0, _useUISettings.useIsHeadless)();
  var roomState = (0, _reactSdk.useHMSStore)(_reactSdk.selectRoomState);
  var prevState = (0, _reactUse.usePrevious)(roomState);
  var isConnectedToRoom = (0, _reactSdk.useHMSStore)(_reactSdk.selectIsConnectedToRoom);
  var hmsActions = (0, _reactSdk.useHMSActions)();
  (0, _react.useEffect)(function () {
    if (!token) {
      navigate("/");
      return;
    }
    if (!prevState && !(roomState === _reactSdk.HMSRoomState.Connecting || roomState === _reactSdk.HMSRoomState.Reconnecting || isConnectedToRoom)) {
      navigate("".concat((0, _utils.getRoutePrefix)(), "/").concat(sessionId, "/preview/").concat(token));
    }
  }, [isConnectedToRoom, prevState, roomState, navigate]);
  (0, _react.useEffect)(function () {
    // beam doesn't need to store messages, saves on unnecessary store updates in large calls
    if (isHeadless) {
      hmsActions.ignoreMessageTypes(["chat"]);
    }
  }, [isHeadless, hmsActions]);
  (0, _react.useEffect)(function () {
    return function () {
      // This is needed to handle mac touchpad swipe gesture
      if (isConnectedToRoom) {
        hmsActions.leave();
      }
    };
  }, [hmsActions, isConnectedToRoom]);
  if (!isConnectedToRoom) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FullPageProgress["default"], {});
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    css: {
      size: "100%"
    },
    direction: "column",
    children: [!isHeadless && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
      css: {
        h: "$18",
        "@md": {
          h: "$17"
        }
      },
      "data-testid": "header",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.Header, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
      css: {
        w: "100%",
        flex: "1 1 0",
        minHeight: 0
      },
      "data-testid": "conferencing",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mainView.ConferenceMainView, {})
    }), !isHeadless && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
      css: {
        flexShrink: 0,
        minHeight: "$24"
      },
      "data-testid": "footer",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Footer.Footer, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_RoleChangeRequestModal.RoleChangeRequestModal, {})]
  });
};
var _default = Conference;
exports["default"] = _default;